import type { LiveCategory } from "./lives";

export interface ChannelCategory {
  key: LiveCategory;
  name: string;
  englishName: string;
  desc: string;
  icon: string;
  liveCount: number;
  cover: string;
}

export const channelCategories: ChannelCategory[] = [
  {
    key: "game",
    name: "游戏",
    englishName: "Gaming",
    desc: "电竞赛事、主机大作、排位冲分应有尽有",
    icon: "ri-gamepad-line",
    liveCount: 1286,
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20gaming%20controller%20and%20neon%20azure%20light%20trails%20on%20dark%20background%2C%20cinematic%20close-up%20product%20photography%20style%2C%20high%20detail%2C%20cool%20tones&width=600&height=400&seq=channel-card-01&orientation=landscape",
  },
  {
    key: "entertainment",
    name: "娱乐",
    englishName: "Entertainment",
    desc: "音乐现场、美食探店、手作电台全天陪伴",
    icon: "ri-music-2-line",
    liveCount: 942,
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20stage%20spotlight%20beams%20and%20silhouette%20crowd%20on%20dark%20background%2C%20concert%20entertainment%20atmosphere%2C%20cinematic%2C%20high%20detail%2C%20cool%20blue%20and%20warm%20amber%20accents&width=600&height=400&seq=channel-card-02&orientation=landscape",
  },
  {
    key: "sports",
    name: "体育",
    englishName: "Sports",
    desc: "足球篮球赛事直播，专业解说多机位呈现",
    icon: "ri-basketball-line",
    liveCount: 618,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20stadium%20floodlights%20and%20an%20abstract%20running%20track%20on%20dark%20background%2C%20energetic%20sports%20atmosphere%2C%20cinematic%20lighting%2C%20high%20detail%2C%20cool%20tones&width=600&height=400&seq=channel-card-03&orientation=landscape",
  },
];